import * as _ from 'lodash';
import JsonApiResource from './jsonapi-resource';

class JsonApiMessage {
  data: JsonApiResource | JsonApiResource[];
  included: JsonApiResource[];
  meta: any;

  constructor(init?) {
    if (init) {
      if (init.data instanceof Array) {
        this.data = init.data.map(item => new JsonApiResource(item));
      } else {
        this.data = new JsonApiResource(init.data);
      }

      if (!_.isNil(init.included)) {
        this.included = init.included.map(item => new JsonApiResource(item));
      } else {
        this.included = [];
      }
    }
  }
}

export default JsonApiMessage;



// WEBPACK FOOTER //
// ./common/models/jsonapi-message.ts